'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const UTM_PREFIX = 'utm_';

const UtmQueryParamsHandler = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const searchParamsString = searchParams.toString();

  useEffect(() => {
    const currentParams = new URLSearchParams(searchParamsString);
    const utmEntries = Array.from(currentParams.entries()).filter(([key]) =>
      key.toLowerCase().startsWith(UTM_PREFIX),
    );

    if (utmEntries.length === 0) {
      return;
    }

    utmEntries.forEach(([key, value]) => {
      sessionStorage.setItem(key, value);
      currentParams.delete(key);
    });

    const cleanedSearch = currentParams.toString();
    const nextUrl = `${pathname}${cleanedSearch ? `?${cleanedSearch}` : ''}${window.location.hash}`;

    router.replace(nextUrl, { scroll: false });
  }, [pathname, router, searchParamsString]);

  return null;
};

export default UtmQueryParamsHandler;
